import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ViewData } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import {  CONFIRMATION_MODE, CONFIRMATION_RESULT } from '@wizeoo/akm-core-lib';
import {
  ConfirmationResultObj,
  WizPopUp,
  WizRoot,
  WizEventManager
} from '@wizeoo/akm-component-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';

/**
 *  guard pour vérifier :
 * - que l'utilisateur peut naviguer (TODO)
 * - qu'il n'y a pas de modification de modèle en cours
 */
@Injectable({ providedIn: 'root' })
export class NavigationCheckGuard implements CanActivate {
  constructor() {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      if (ViewData.wizUpdateModel || ViewData.wizWidgetUpdate) {
        // True : le modèle à changé
        // ouverture de la popup
        // l'Observer est passé en tant que data
        WizPopUp.confirm(
          '$.cancel.update.pop.title.$',
          '$.cancel.update.pop.content.$',
          this.popupConfirmationCallback,
          CONFIRMATION_MODE.CONFIRM_CANCEL,
          observer
        ).show();
      } else {
        // if there is no modification
        observer.next(true);
        observer.complete();
      }
    });
  }

  /**
   * Callback de la  WizPopupConfirmation
   * @param confirmationResult : retour normé sur pop de validation de navigation
   */
  popupConfirmationCallback(confirmationResult: ConfirmationResultObj) {
    if (confirmationResult.result === CONFIRMATION_RESULT.CONFIRM) {
      // modification of the update model value
      WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));

      // returns a value to the observable
      confirmationResult.data.next(true);
      confirmationResult.data.complete();
    }
  }
}
